import {
  MessageTemplateApiMessageTemplateCreateRequest,
  MessageTemplateApiMessageTemplateCreateResponse,
  MessageTemplateApiMessageTemplateDeleteRequest,
  MessageTemplateApiMessageTemplateDeleteResponse,
  MessageTemplateApiMessageTemplateListRequest,
  MessageTemplateApiMessageTemplateListResponse,
  MessageTemplateApiMessageTemplateUpdateRequest,
  MessageTemplateApiMessageTemplateUpdateResponse
} from "../../proto/generated/api_entities_pb";
import {API} from "../API";
import {MessageTemplateApiServiceClient} from "../../proto/generated/api_entities_grpc_web_pb";
import {getProxyUrl} from "../helpers/getProxyUrl";

const client = new MessageTemplateApiServiceClient(getProxyUrl(), null, null);

export class MessageTemplateApi {
  static async messageTemplateCreate(req: MessageTemplateApiMessageTemplateCreateRequest): Promise<MessageTemplateApiMessageTemplateCreateResponse> {
    return new Promise((resolve, reject) => {
      API.call<MessageTemplateApiMessageTemplateCreateRequest, MessageTemplateApiMessageTemplateCreateResponse>(
        client, 
        client.messageTemplateCreate, 
        req, 
        resolve, 
        reject
      );
    });
  }

  static async messageTemplateUpdate(req: MessageTemplateApiMessageTemplateUpdateRequest): Promise<MessageTemplateApiMessageTemplateUpdateResponse> {
    return new Promise((resolve, reject) => {
      API.call<MessageTemplateApiMessageTemplateUpdateRequest, MessageTemplateApiMessageTemplateUpdateResponse>(
        client, 
        client.messageTemplateUpdate, 
        req, 
        resolve, 
        reject
      );
    });
  }

  static async messageTemplateDelete(req: MessageTemplateApiMessageTemplateDeleteRequest): Promise<MessageTemplateApiMessageTemplateDeleteResponse> {
    return new Promise((resolve, reject) => {
      API.call<MessageTemplateApiMessageTemplateDeleteRequest, MessageTemplateApiMessageTemplateDeleteResponse>(
        client, 
        client.messageTemplateDelete, 
        req, 
        resolve, 
        reject
      );
    });
  }

  static async messageTemplateList(req: MessageTemplateApiMessageTemplateListRequest): Promise<MessageTemplateApiMessageTemplateListResponse> {
    return new Promise((resolve, reject) => {
      API.call<MessageTemplateApiMessageTemplateListRequest, MessageTemplateApiMessageTemplateListResponse>(
        client, 
        client.messageTemplateList, 
        req, 
        resolve, 
        reject
      );
    });
  }
}

